import {countThresholdDays} from "./countThresholdDays"

export const sortByPercentOfTaxThreshold = (currentDate, data = []) =>
  data.sort((a, b) => {
    // Prepare the percent values by counting the threshold days and dividing by days allowed
    const aPercent =
      countThresholdDays(currentDate, a.jurisdiction, a.travelDates) /
      a.daysAllowed
    const bPercent =
      countThresholdDays(currentDate, b.jurisdiction, b.travelDates) /
      b.daysAllowed
    // Subtract the second percent from the first
    return bPercent - aPercent
  })
